import type { IBackgroundProvider } from './IBackgroundProvider';
import type { StyleModel } from '@paperbits/common/styles/styleModel';

export class NullBackgroundProvider implements IBackgroundProvider {
    public async provide(): Promise<StyleModel | undefined> {
        return;
    }
}